import { ethers } from "ethers";
import Base721 from "./Base721";
import config from "../config";
import vxabi from "../abis/vx.json";

class VXContract extends Base721 {
    constructor(signer: ethers.Signer | ethers.providers.Provider) {
        super(config.vxBearsAddress, vxabi, signer);
    }

    /**
     * Check if a VX token with the given ID exists (has been minted)
     * Uses the contract's native exists() function for accuracy
     * @param tokenId - The token ID to check
     * @returns true if the token exists, false otherwise
     */
    async exists(tokenId: number): Promise<boolean> {
        try {
            // Use the contract's native exists function directly
            const result = await this.contract.exists(tokenId);
            console.log(`VX exists check for token ${tokenId}:`, result);
            return result;
        } catch (error) {
            console.error(`Error checking VX exists for token ${tokenId}:`, error);
            return false;
        }
    }
}

export default VXContract;